export const SITE = {
  brand: "HG Corporates",
  founder: "Bhavik Hariyani",
  parent: "HG Corporates",
  email: "info@hgcorporates.com",
  phone: "+91 97 97 193 555",
  whatsappNumber: "919797193555",
  whatsappUrl:
    "https://wa.me/919797193555?text=" +
    encodeURIComponent(
      "Hi Bhavik, I'm a First-Time Founder exploring HG Corporates. Can we talk?",
    ),
  address:
    "Office No.708, 7th Floor,\nNirmal Ecstasy Business Park,\nNear East-West Flyover,\nMulund (West), Mumbai - 400080",
  addressShort: "Mulund (West), Mumbai",
  googleRating: 4.9,
  googleReviewCount: 251,
  googleReviewsUrl: "https://share.google/7rtk1rmM3CMC8qAcc",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Entity Advisor", to: "/entity-advisor" },
  { label: "First-Time Founders", to: "/first-time-founders" },
  { label: "Resources", to: "/resources" },
  { label: "FAQs", to: "/faqs" },
  { label: "Reviews", to: "/reviews" },
  { label: "Contact", to: "/contact" },
];
